'use es6';

export default Object.freeze({
  templates: 'ide-dnd-editor',
  code: 'ide-coded-file-editor',
  modules: 'ide-custom-module-editor',
  empty: 'ide-empty-state',
  settings: 'ide-settings',
  'global-modules': 'ide-custom-module-editor',
  welcome: 'ide-welcome',
  'not-found': 'not-found',
  file: 'ide-raw-asset-editor',
  folder: 'ide-folder-editor',
  'getting-started': 'ide-getting-started'
});